module.exports = __webpack_public_path__ + "img/Coupe_Side_Right.40f21f10.svg";